import styled from "styled-components"


const NumericalValue = styled.div`
    color: ${({ theme }) => theme.valueTextColor};
    pointer-events: auto;
    font-size: 1.2em;
    align-self: center;
    padding: 0;
    margin: 0, auto;
    text-align: left;
    vertical-align: center;
`;

export default NumericalValue
